import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getToken } from '../../services/api'; // Assurez-vous que cette fonction est définie correctement
import './Login.css';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [emailError, setEmailError] = useState('');
  const [passwordError, setPasswordError] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalMessage, setModalMessage] = useState('');
  const navigate = useNavigate();

  const validateInputs = () => {
    let valid = true;
    if (!email) {
      setEmailError('L\'email est requis.');
      valid = false;
    } else {
      setEmailError('');
    }

    if (!password) {
      setPasswordError('Le mot de passe est requis.');
      valid = false;
    } else {
      setPasswordError('');
    }

    return valid;
  };

  const handleLogin = async () => {
    if (!validateInputs()) return;

    try {
      const token = await getToken(email, password);
      if (token) {
        localStorage.setItem('token', token);
        navigate('/accueil');
      } else {
        setModalMessage('Identifiants incorrects');
        setIsModalOpen(true);
      }
    } catch (error) {
      console.error('Erreur lors de la connexion :', error);
      setModalMessage('Une erreur est survenue. Veuillez réessayer.');
      setIsModalOpen(true);
    }
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <div className="mainContainer">
      {/* Conteneur du logo Eureka */}
      <div className="leftContainer">
        <img src="logo.png" alt="Logo Eureka" className="logo" />
      </div>

      {/* Conteneur du formulaire */}
      <div className="formContainer">
        <div className="titleContainer">
          <h2>Veuillez vous connecter</h2>
        </div>
        <div className="inputContainer">
          <input
            type="text"
            value={email}
            placeholder="Entrez votre email ici"
            onChange={(ev) => setEmail(ev.target.value)}
            className="inputBox"
          />
          <label className="errorLabel">{emailError}</label>
        </div>
        <div className="inputContainer">
          <input
            type="password"
            value={password}
            placeholder="Entrez votre mot de passe ici"
            onChange={(ev) => setPassword(ev.target.value)}
            className="inputBox"
          />
          <label className="errorLabel">{passwordError}</label>
        </div>
        <div className="inputContainer">
          <button className="inputButton" onClick={handleLogin}>
            Se connecter
          </button>
        </div>

        {/* Modale d'erreur */}
        {isModalOpen && (
          <div className="modal">
            <div className="modalContent">
              <p>{modalMessage}</p>
              <button onClick={closeModal}>Fermer</button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Login;
